import OrderType from './OrderType';

export default {
  OrderType,
};
